import * as React from 'react';
import Icon from 'react-fa';
import Rating from '../../components/Rating';
import geolib from 'geolib';
import round from 'lodash/round'
import classNames from 'classnames';
import { LinkHelper } from '../../routes';
import LinkButton from '../../components/Button/LinkButton';
import isNumber from 'lodash/isNumber';
const metersToMiles = (distance) => distance/1000/1.609344;
const getMiles = (p1, p2) => metersToMiles(geolib.getDistance(p1, p2));
const styles = require('./Search.less') as any;

import debounce from 'lodash/debounce';
import { Activatable } from '../utils'
import ReactDOM from 'react-dom';
import { scrollIntoViewIfNeeded } from '../../utils/scrollIntoViewIfNeeded';
class SearchResult extends React.Component< any,any> {
  scrollIntoViewIfNeeded() { scrollIntoViewIfNeeded(ReactDOM.findDOMNode(this)); }
  isSelected() {
    return this.props.id === this.props.selected;
  }
  componentDidMount() {
    if (this.isSelected()) this.scrollIntoViewIfNeeded();
  }
  componentDidUpdate(prevProps) {
    // Only scroll if selection changed
    if (this.isSelected() && (prevProps.selected != this.props.selected)) {
      this.scrollIntoViewIfNeeded();
    }
  }
  setResultHovered() {
    this.props.setResultHovered(this.props.id);
  }
  render() {
    const {
      id, name, distance, arb, location, position, selected, hovered, setResultSelected, setResultHovered, isMobile=false
    } = this.props;
		const [ isSelected, isHovered ] = [id==selected, id==hovered];
		const classes = classNames(
			styles.SearchResult,
			isSelected && styles.selected,
			isHovered && styles.hovered
		)

		return (
			<Activatable onActivate={() => setResultSelected(id)}
					onFocus={() => debounce(this.setResultHovered)}
									 onMouseOver={() => debounce(this.setResultHovered)}
			onMouseOut={() => setResultHovered(null)}
			className={classes}
			Element='li'>
				<div className={styles.ResultMain}>
					<div className={styles.ResultInfo}>
						<span className={styles.name}>{ name }</span>
						<address>{location.address}</address>
						<Rating classes={styles.Rating}
										rating={arb.rating} reviewers={arb.reviewers} review_count={arb.review_count} name={`${id}-rating`} />
					</div>
					<div className={styles.Right}>
						{isHovered && !isSelected && <Icon name='chevron-circle-right' />}
						<div className={styles.distance}>{round(getMiles(location.position, position), 2)} mi.</div>
					</div>
				</div>
				{isSelected && (
					 <div className={classNames(styles.resultOptions)}>
						 {(isNumber(arb.rating.personalized) || isNumber(arb.rating.average)) && <LinkButton to={`/place/${id}`}>View Reviews</LinkButton>}
						 <LinkButton to={`/place/${id}?reviewing`}>
							 {arb.rating.user_rated ? 'Edit Your Review' : 'Write a review' }
							 {/* {isEmpty(arb.my_reviews) ? "Submit a Review" : "Edit Your Review"} */}
						 </LinkButton>
					 </div>)}
			</Activatable>
		);
  }
}

export default SearchResult;



// WEBPACK FOOTER //
// ./src/app/containers/Search/SearchResult.tsx